(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var data = JSON.parse(root.querySelector('[data-ppb-data]').textContent);
      if (!data.flavours.length) return;
      var T = data.t;
      // Closed country picked in the header: show its prices, ordering stays off.
      var pc = window.ppCountry;
      if (pc) {
        data.currency = pc.currency;
        data.home = pc.code;
        data.duoPrice = pc.prices['60'];
        data.duoBase = pc.prices['30'];
        data.flavours.forEach(function (f) {
          f.variants.forEach(function (v) {
            var np = pc.prices[v.size];
            if (np == null) return;
            v.price = np;
            v.compare = pc.prices['was' + v.size] || 0;
            Object.keys(v.plans).forEach(function (id) { v.plans[id] = Math.round(np * (100 - data.subPct) / 100); });
          });
        });
      }
      var dec = document.createElement('textarea');
      Object.keys(T).forEach(function (k) { dec.innerHTML = T[k]; T[k] = dec.value; });
      var lang = document.documentElement.lang || 'sv';
      function money(c) {
        var n = c / 100;
        try {
          return new Intl.NumberFormat(lang, { style: 'currency', currency: data.currency || 'SEK', minimumFractionDigits: Number.isInteger(n) ? 0 : 2, maximumFractionDigits: 2 }).format(n);
        } catch (e) {
          return (Number.isInteger(n) ? String(n) : n.toFixed(2).replace('.', ',')) + ' kr';
        }
      }
      var hidden = data.hidden.map(function (s) { return parseInt(s, 10); });
      var state = { flavour: null, key: null, mode: data.defaultMode, plan: null };
      var el = function (s) { return root.querySelector(s); };

      function flav() { return data.flavours.find(function (f) { return f.handle === state.flavour; }) || data.flavours[0]; }
      function hasPlans() { return flav().plans.length > 0; }
      function nums(a) { return (a || []).map(function (s) { return parseInt(s, 10); }).filter(function (n) { return n > 0; }); }
      var clearance = nums(data.clearance), subSizes = nums(data.subSizes);
      // All cards for the flavour, before the subscribe/one-time filter.
      function allCards() {
        var f = flav(), list = [];
        var only = nums(f.only), soon = nums(f.soon);
        f.variants.filter(function (v) { return only.length ? only.indexOf(v.size) !== -1 : hidden.indexOf(v.size) === -1; })
          .sort(function (a, b) { return a.size - b.size; })
          .forEach(function (v) {
            var c = { key: 'v' + v.size, v: v, qty: 1, size: v.size, name: data.names[v.size] || (v.size + ' ' + T.many), badge: data.badges[v.size] || '' };
            if (soon.indexOf(v.size) !== -1) { c.soon = true; c.badge = T.soon; }
            else if (clearance.indexOf(v.size) !== -1) {
              if (!v.available) return; // clearance packs disappear when sold out
              c.clearance = true;
              c.badge = T.clearance + (v.compare > v.price ? ' −' + Math.round((1 - v.price / v.compare) * 100) + ' %' : '');
            }
            list.push(c);
            if (v.size === 30 && data.duoPrice > 0 && v.price === data.duoBase) list.push({ key: 'duo', v: v, qty: 2, size: 60, name: data.names['60'], badge: data.badges['60'], duo: true });
          });
        return list;
      }
      function hasPlan(c) { return Object.keys(c.v.plans).length > 0; }
      function subCards() {
        // Clearance packs can't be subscribed, but stay listed (one-time price); picking one switches to "Buy once".
        return allCards().filter(function (c) { return !c.soon && (c.clearance ? c.v.available : hasPlan(c) && (!subSizes.length || subSizes.indexOf(c.size) !== -1)); });
      }
      function canSubscribe() { return hasPlans() && subCards().some(function (c) { return !c.clearance; }); }
      function cards() { return state.mode === 'sub' && canSubscribe() ? subCards() : allCards(); }
      function priceOf(c, sub) {
        if (c.duo) {
          if (!sub) return data.duoPrice;
          if (data.duoSub) return Math.round(data.duoPrice * (100 - data.subPct) / 100);
          return (state.plan && c.v.plans[state.plan] != null ? c.v.plans[state.plan] : c.v.price) * 2;
        }
        var unit = c.v.price;
        if (sub && state.plan && c.v.plans[state.plan] != null) unit = c.v.plans[state.plan];
        return unit * c.qty;
      }
      function current() { return cards().find(function (c) { return c.key === state.key; }); }
      function subActive() { return state.mode === 'sub' && canSubscribe() && current() && !current().clearance && hasPlan(current()); }
      function orderable(c) { return c && !c.soon && c.v.available; }

      var whiteSizes = nums(data.whiteSizes);
      var galleryKey = '';
      // Photos of the packs on offer, smallest to biggest; the selected pack's photo is shown large.
      function galleryItems() {
        var f = flav(), seen = {}, out = [];
        cards().slice().sort(function (a, b) { return a.size - b.size; }).forEach(function (c) {
          var v = c.v;
          if (v && v.img && !seen[v.img]) { seen[v.img] = 1; out.push({ src: v.img, white: whiteSizes.indexOf(v.size) !== -1, soon: c.soon ? c.name : '' }); }
        });
        if (!out.length) f.images.forEach(function (src) { out.push({ src: src, white: false }); });
        return out;
      }
      function setMain(it) {
        var main = el('[data-main]');
        main.src = it ? it.src : '';
        main.parentNode.classList.toggle('is-white', !!(it && it.white));
        // A photo of a pack that can't be ordered yet says so.
        var note = el('[data-main-note]');
        note.hidden = !(it && it.soon);
        note.textContent = it && it.soon ? T.soonPhoto.replace('{pack}', it.soon) : '';
        el('[data-thumbs]').querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-current', it && x.dataset.src === it.src ? 'true' : 'false'); });
      }
      function renderGallery() {
        var items = galleryItems(), th = el('[data-thumbs]'), cur = current();
        var key = items.map(function (x) { return x.src; }).join('|');
        if (key !== galleryKey) {
          galleryKey = key;
          th.innerHTML = '';
          items.slice(0, 6).forEach(function (it, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = it.white ? 'is-white' : '';
            b.dataset.src = it.src;
            b.setAttribute('aria-label', T.image + ' ' + (i + 1));
            b.innerHTML = '<img src="' + it.src.replace('width=1200', 'width=200') + '" alt="" loading="lazy">';
            b.onclick = function () { setMain(it); };
            th.appendChild(b);
          });
        }
        setMain(items.find(function (x) { return cur && x.src === cur.v.img; }) || items[0]);
      }
      function render() {
        var f = flav();
        root.querySelectorAll('[data-flavour]').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.flavour === f.handle ? 'true' : 'false'); });
        var canSub = canSubscribe();
        el('[data-modes]').hidden = !canSub;
        if (hasPlans() && !f.plans.find(function (p) { return String(p.id) === state.plan; })) state.plan = String(f.plans[0].id);
        var modeNow = canSub ? state.mode : 'once';
        root.querySelectorAll('[data-mode]').forEach(function (b) { b.setAttribute('aria-selected', b.dataset.mode === modeNow ? 'true' : 'false'); });
        var list = cards();
        if (!list.find(function (c) { return c.key === state.key && orderable(c); })) {
          var pref = list.find(function (c) { return c.key === (modeNow === 'sub' ? 'duo' : 'v30') && orderable(c); }) || list.find(function (c) { return orderable(c) && !(modeNow === 'sub' && c.clearance); }) || list[0];
          state.key = pref && pref.key;
        }
        var sub = subActive();
        var packs = el('[data-packs]');
        packs.innerHTML = '';
        list.forEach(function (c) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ppb__pack' + (c.clearance ? ' ppb__pack--sale' : '') + (c.soon ? ' ppb__pack--soon' : '');
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', c.key === state.key ? 'true' : 'false');
          if (!orderable(c)) b.disabled = true;
          var p = priceOf(c, sub && hasPlan(c) && !c.clearance);
          var full = Math.max(c.v.compare || 0, c.v.price) * c.qty;
          var was = p < full ? '<s>' + money(full) + '</s>' : '';
          var subline = c.size + ' ' + (c.size === 1 ? T.one : T.many);
          if (c.soon) subline = T.soon;
          else if (!c.v.available) subline = T.soldOut;
          else if (c.clearance) subline = (c.v.stock != null && c.v.stock <= data.lowStock ? T.onlyLeft.replace('{n}', c.v.stock) : T.whileStock) + (modeNow === 'sub' ? ' · ' + T.onceOnly : '');
          b.innerHTML = (c.badge ? '<span class="ppb__badge">' + c.badge + '</span>' : '') +
            '<span class="ppb__radio"></span>' +
            '<span class="ppb__pack-name">' + c.name + '<span class="ppb__pack-sub">' + subline + '</span></span>' +
            (c.soon ? '<span class="ppb__price">' + money(p) + '</span>' :
              '<span class="ppb__price">' + was + money(p) + '<small>' + money(Math.round(p / c.size)) + T.per + '</small></span>');
          b.onclick = function () { state.key = c.key; if (c.clearance) state.mode = 'once'; render(); };
          packs.appendChild(b);
        });
        if (!list.some(function (x) { return x.size === 120; })) {
          var other = bigCard();
          if (other) packs.appendChild(other);
        }
        var c = current();
        var freqs = el('[data-freqs]');
        el('[data-freq-wrap]').hidden = !(sub && f.plans.length > 1);
        freqs.innerHTML = '';
        f.plans.forEach(function (pl) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', String(pl.id) === state.plan ? 'true' : 'false');
          // Only the interval: the heading already says "deliver every" and the toggle shows the discount.
          b.textContent = pl.name.split(',')[0].replace(/^.*?\b(var|every|alle)\s+/i, '');
          b.onclick = function () { state.plan = String(pl.id); render(); };
          freqs.appendChild(b);
        });
        el('[data-perks-sub]').hidden = !sub;
        var price = c ? priceOf(c, sub) : 0;
        var hint = el('[data-hint]');
        // Free-shipping messages are for Sweden only (SEK limit); abroad, checkout shows the country's rate.
        hint.hidden = !c || c.soon || (data.home !== 'SE' && !pc);
        var freeLimit = sub ? data.freeShippingSub : data.freeShipping;
        if (pc) hint.textContent = pc.shipText;
        else if (c && c.duo && !sub) hint.textContent = T.duoHint;
        else if (c && freeLimit && price < freeLimit) hint.textContent = (sub ? T.freeLeftSub : T.freeLeft).replace('{amount}', money(freeLimit)).replace('{left}', money(freeLimit - price));
        else if (c) hint.textContent = sub ? T.freeIncludedSub : T.freeIncluded;
        var label = pc ? pc.cta : !c ? T.soldOut : c.soon ? T.soon : !c.v.available ? T.soldOut : (sub ? T.subscribe : T.add) + ' · ' + money(price);
        var cta = el('[data-cta]');
        cta.textContent = label;
        cta.disabled = !orderable(c) || !!pc;
        var sticky = el('[data-cta-sticky]');
        sticky.disabled = cta.disabled;
        sticky.textContent = pc ? pc.cta : c && c.soon ? T.soon : (sub ? T.subscribe : T.add);
        var packName = c && c.name !== f.label ? ' · ' + c.name : '';
        el('[data-sticky-text]').innerHTML = '<b>' + f.label + '</b>' + packName + ' · ' + money(price);
        renderGallery();
        document.dispatchEvent(new CustomEvent('pp:select', { detail: { handle: f.handle, flavour: f.label, size: c ? c.v.size : null, pack: c && c.name !== f.label ? c.name : '' } }));
        window.ppSelection = { handle: f.handle, flavour: f.label, size: c ? c.v.size : null, pack: c && c.name !== f.label ? c.name : '' };
      }
      // Flavours sold as a 120-pack, so the pack stays visible on the flavours that don't have one.
      function bigFlavours() {
        return data.flavours.filter(function (fl) {
          var only = nums(fl.only);
          var v = fl.variants.find(function (x) { return x.size === 120 && x.available; });
          return v && (only.length ? only.indexOf(120) !== -1 : hidden.indexOf(120) === -1);
        });
      }
      function bigCard() {
        var big = bigFlavours();
        if (!big.length) return null;
        var v = big[0].variants.find(function (x) { return x.size === 120; });
        var p = state.mode === 'sub' && canSubscribe() && state.plan && v.plans[state.plan] != null ? v.plans[state.plan] : v.price;
        var names = big.map(function (fl) { return fl.label; });
        var last = names.pop();
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ppb__pack ppb__pack--other';
        b.innerHTML = '<span class="ppb__badge">' + data.badges['120'] + '</span><span class="ppb__radio"></span>' +
          '<span class="ppb__pack-name">' + data.names['120'] + '<span class="ppb__pack-sub">' + T.availableIn.replace('{flavours}', (names.length ? names.join(', ') + T.and : '') + last) + '</span></span>' +
          '<span class="ppb__price">' + (p < v.price ? '<s>' + money(v.price) + '</s>' : '') + money(p) + '<small>' + money(Math.round(p / 120)) + T.per + '</small></span>';
        b.onclick = function () { state.key = 'v120'; setFlavour(big[0].handle, true); };
        return b;
      }
      function setFlavour(h, push) {
        state.flavour = h;
        render();
        if (push && /\/products\//.test(location.pathname)) {
          try { history.replaceState(null, '', flav().url); } catch (e) {}
        }
      }
      function add() {
        var c = current();
        if (!orderable(c) || pc) return;
        var item = { id: c.v.id, quantity: c.qty };
        if (subActive() && state.plan) item.selling_plan = parseInt(state.plan, 10);
        var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var body = { items: [item] };
        if (drawer && drawer.getSectionsToRender) {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        var root_ = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
        var err = el('[data-error]');
        err.hidden = true;
        var cta = el('[data-cta]');
        cta.disabled = true;
        fetch(root_ + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (res) {
          cta.disabled = false;
          if (res.status && res.description) { err.textContent = res.description; err.hidden = false; return; }
          if (drawer && drawer.renderContents && res.sections) {
            res.id = c.v.id;
            if (res.items && res.items[0]) res.key = res.items[0].key;
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = root_ + 'cart';
          }
        }).catch(function () { cta.disabled = false; window.location.href = root_ + 'cart'; });
      }

      root.querySelectorAll('[data-flavour]').forEach(function (b) { b.onclick = function () { setFlavour(b.dataset.flavour, true); }; });
      root.querySelectorAll('[data-mode]').forEach(function (b) { b.onclick = function () { state.mode = b.dataset.mode; render(); }; });
      el('[data-cta]').onclick = add;
      el('[data-cta-sticky]').onclick = add;
      var sticky = el('[data-sticky]');
      if ('IntersectionObserver' in window) {
        var pastCta = false, atEnd = {};
        var updateSticky = function () {
          // Off at the end of the page, so it never covers the contact tiles or footer links.
          var on = pastCta && !Object.keys(atEnd).some(function (k) { return atEnd[k]; });
          sticky.classList.toggle('is-on', on);
          sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          el('[data-cta-sticky]').tabIndex = on ? 0 : -1;
        };
        // Checked on scroll, since a long jump up the page can skip past the button unnoticed by an observer.
        var checkCta = function () {
          pastCta = el('[data-cta]').getBoundingClientRect().bottom < 0;
          updateSticky();
        };
        window.addEventListener('scroll', checkCta, { passive: true });
        checkCta();
        var endObserver = new IntersectionObserver(function (es) {
          es.forEach(function (e) { atEnd[e.target.id || e.target.tagName] = e.isIntersecting; });
          updateSticky();
        });
        document.querySelectorAll('#kontakt, footer').forEach(function (n) { endObserver.observe(n); });
      }
      var start = data.flavours.find(function (f) { return f.handle === data.start; }) ? data.start : data.flavours[0].handle;
      setFlavour(start, false);
    }
    function boot() { document.querySelectorAll('.ppb').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-popup"]) return;
  try {
    
  (function () {
    var KEY = 'pp_popup_state';
    function get() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
    function set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

    function init() {
      var root = document.querySelector('[data-pp-popup]');
      if (!root || root.dataset.ready) return;
      root.dataset.ready = '1';
      var editor = root.dataset.editor === '1';
      var code = root.dataset.code;
      var answer = '';
      var lastFocus = null;
      var state = get();
      var repeat = parseInt(root.dataset.repeat, 10) || 14;
      if (!editor && state) {
        if (state.done) return;
        if (state.closed && Date.now() - state.closed < repeat * 864e5) return;
      }
      function step(n) {
        root.querySelectorAll('[data-step]').forEach(function (s) { s.hidden = s.dataset.step !== String(n); });
        var f = root.querySelector('[data-step="' + n + '"] button, [data-step="' + n + '"] input');
        if (f) f.focus();
      }
      var shown = false;
      function open() {
        if (shown) return;
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.classList.contains('active')) return;
        shown = true;
        clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        lastFocus = document.activeElement;
        root.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        step(1);
      }
      function close(final) {
        root.hidden = true;
        document.documentElement.style.overflow = '';
        if (!editor) set(final ? { done: Date.now() } : { closed: Date.now() });
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      function reveal() {
        step(3);
        set({ done: Date.now() });
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      }

      root.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', function () { close(false); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(false); });
      root.querySelectorAll('[data-answer]').forEach(function (b) {
        b.addEventListener('click', function () { answer = b.dataset.answer; step(2); });
      });
      var skip = root.querySelector('[data-skip]');
      if (skip) skip.addEventListener('click', reveal);
      var form = root.querySelector('[data-email-form]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input');
        var err = root.querySelector('[data-email-err]');
        var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
        err.hidden = ok;
        if (!ok) { input.focus(); return; }
        var fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[email]', input.value.trim());
        fd.append('contact[tags]', 'newsletter,popup-15,boost-' + (answer || 'unknown'));
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
        reveal();
      });
      root.querySelector('[data-copy]').addEventListener('click', function (e) {
        var b = e.currentTarget, label = b.textContent;
        var done = function () { b.textContent = b.dataset.copied; setTimeout(function () { b.textContent = label; }, 1500); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      });
      root.querySelector('[data-shop]').addEventListener('click', function () {
        close(true);
        var shop = document.getElementById('shop');
        if (shop) shop.scrollIntoView({ behavior: 'smooth' }); else window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '#shop';
      });

      var timer = null;
      function onScroll() {
        var h = document.documentElement;
        if ((h.scrollTop + innerHeight) / h.scrollHeight > 0.45) open();
      }
      if (editor) {
        // In the theme editor, only show while the popup section is selected.
        document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(root)) { shown = false; open(); } });
        document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(root)) close(); });
        return;
      }
      timer = setTimeout(open, (parseInt(root.dataset.delay, 10) || 8) * 1000);
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('[data-pp-popup]')) init(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function dlg() { return document.querySelector('[data-pp-story]'); }
    function open(e) {
      var d = dlg();
      if (!d) return;
      if (e) e.preventDefault();
      if (!d.open) { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); }
    }
    function close() { var d = dlg(); if (d && d.open) d.close(); }
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-pp-story-open]');
      if (o && dlg()) return open(e);
      if (e.target.closest('[data-pp-story-close]')) return close();
      var d = dlg();
      if (d && d.open && e.target === d) close();
    });
    function boot() { if (location.hash === '#om-oss') open(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();
})();
